import TabView from './TabView';
import * as utils from './utils';
import TabCardView from './SideTabView';
import LayoutDependentTabView from './LayoutDependentTabView';
import { useIsInSideTabContentContainer } from './hooks';

export { TabView, TabCardView, useIsInSideTabContentContainer, LayoutDependentTabView };

//github.com/webpack/webpack/issues/7378#issuecomment-492641148
export type TabOption = utils.TabOption;
export type BaseTabViewProps = utils.BaseTabViewProps;
